import { TB } from "../../../Constants";
import renderInContainer from "../getContainer";
import { Select, SelectProps } from "../Components";

export type AskSelectProps = Omit<SelectProps, 'onValidate' | 'onQuit' | 'extraButton'> & {
    /** Callback to render an extra button in the footer */
    renderExtraButton?: (resolve: (param: any) => void) => React.ReactNode;
    /** Callback for creating a new option */
    create_option?: (text: string, resolve: (option: string) => void) => void;
};;

const askSelect = (params: AskSelectProps) => new Promise<Parameters<SelectProps["onValidate"]>[0]>(resolve => {
    const [render, dismount] = renderInContainer();
    if (!TB.validObject(params)) params = {};
    if (render && dismount) {
        const selectProps = params?.selectProps || {};
        const onQuit = () => dismount(() => resolve(null));
        const onValidate = (confirmed?: string) => dismount(() => resolve(confirmed));
        const extra_button = typeof params?.renderExtraButton === "function" ? params.renderExtraButton(onValidate) : undefined;

        if (params?.create_option) {
            selectProps.allowNewOption = true;
            selectProps.onAddOption = text => dismount(() => params.create_option(text, resolve));
        };
        render(<Select {...params} selectProps={selectProps} onQuit={onQuit} onValidate={onValidate} extraButton={extra_button} />);
    }
    else resolve(null);
});

export default askSelect;